import React, { useState } from 'react'
import HomeWeServeList from './HomeWeServeList'
import { TabletAndLarger } from '../../shared/responsive-breakpoints'

const HomeWeServe = ({ weServeData }) => {
  const { header, slogan } = weServeData
  const [activeServiced, setActiveServiced] = useState(weServeData.serviceList[0].fields)
  const changeActiveServiced = activeServiced => {
    setActiveServiced(activeServiced)
  }

  return (
    <section className="dealmed-home-serve" aria-labelledby="dealmed-home-serve-heading">
      <div className="dealmed-container">
        <span className="dealmed-home-serve__span">{header}</span>
        <h2 className="dealmed-home-serve__heading" id="dealemd-home-serve-heading">
          {slogan}
        </h2>
        <div className="dealmed-home-serve__content">
          <TabletAndLarger>
            <div className="dealmed-home-serve__banner">
              <div className="dealmed-home-serve__banner-wrapper">
                <a
                  href={activeServiced.pdfDownload.fields.file.url}
                  className="dealmed-home-serve__banner-download"
                  download={true}
                  aria-label="Download PDF"
                >
                  <img
                    src={activeServiced.image.fields.file.url}
                    className="dealmed-home-serve__banner-image"
                    alt=""
                    loading="lazy"
                  />
                </a>
              </div>
            </div>
          </TabletAndLarger>
          <HomeWeServeList
            serviceList={weServeData.serviceList.map(service => service.fields)}
            activeServiced={activeServiced}
            changeActiveServiced={changeActiveServiced}
          />
        </div>
      </div>
    </section>
  )
}

export default HomeWeServe
